import { Link, Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import HealthBanner from './HealthBanner';
import Toaster from './Toaster';
import { PAGE_WIDTH } from './container';
import VenueUrlSync from '../venue/VenueUrlSync';
import OrderToasts from '../account/orders/OrderToasts';
import { useT } from '../i18n/useT';
import BrowseOnlyBanner from '../geo/BrowseOnlyBanner';
import { useGeo } from '../geo/context';
import { MARKETS_MIN_PAGE_HEIGHT, MARKETS_MIN_PAGE_HEIGHT_NO_ACCOUNT, useMarketsFill, useMarketsMiniPortfolio } from '../catalog/prefs';
import { useViewedAccount } from '../wallet/context';

export default function Layout() {
  const t = useT();
  const geo = useGeo();
  const markets = useLocation().pathname === '/';
  // #2242: compact Markets on a desktop is exactly one screen high (the list and the panel scroll inside themselves).
  const fill = useMarketsFill();
  // Rev 3: with the mini portfolio under the list the page has a floor, and a shorter window scrolls instead.
  const mini = useMarketsMiniPortfolio();
  const hasAccount = useViewedAccount().address !== null;
  return (
    <div
      className={fill ? 'flex h-dvh flex-col overflow-hidden' : 'flex min-h-screen flex-col'}
      style={mini ? { minHeight: hasAccount ? MARKETS_MIN_PAGE_HEIGHT : MARKETS_MIN_PAGE_HEIGHT_NO_ACCOUNT } : undefined}
      data-fill={fill ? 'true' : undefined}
    >
      <VenueUrlSync />
      <Header />
      <BrowseOnlyBanner />
      <HealthBanner />
      {/* Markets starts right under the header (#2242: no blank band above the search box and the panel). */}
      <main
        className={`${PAGE_WIDTH} flex-1 ${
          fill ? 'flex min-h-0 flex-col py-2' : markets ? 'pb-6 pt-2' : 'py-6'
        }`}
      >
        <Outlet />
      </main>
      <footer className={`border-t border-border px-4 text-center text-xs text-muted ${fill ? 'py-1.5' : 'py-3'}`}>
        {t('shell.footer.tagline')}{' '}
        <Link to="/learn" className="text-accent hover:underline" data-testid="footer-learn">
          {t('shell.footer.how_it_works')}
        </Link>
        {' · '}
        <Link to="/privacy" className="text-accent hover:underline" data-testid="footer-privacy">
          {t('common.privacy')}
        </Link>
        {' · '}
        <button type="button" onClick={geo.showTerms} className="text-accent hover:underline" data-testid="footer-terms">
          {t('terms.footer_link')}
        </button>
      </footer>
      <OrderToasts />
      <Toaster />
    </div>
  );
}
